import { render, staticRenderFns } from "./TwBenchmarkPagination.vue?vue&type=template&id=21cf1ebe&scoped=true"
import script from "./TwBenchmarkPagination.vue?vue&type=script&lang=ts"
export * from "./TwBenchmarkPagination.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmarkPagination.vue?vue&type=style&index=0&id=21cf1ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf1ebe",
  null
  
)

export default component.exports